import { render, staticRenderFns } from "./LogoFake.vue?vue&type=template&id=6616963d&"
import script from "./LogoFake.vue?vue&type=script&lang=js&"
export * from "./LogoFake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports